var _path, _path2, _circle, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMfacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20859 40.0711C9.20859 40.0711 9.46687 38.6445 10.4825 41.9992C11.4982 45.354 22.9827 52.6964 26.8271 46.75C30.6715 40.8036 36.1066 47.4763 39.861 45.6917C43.6155 43.907 44.2102 41.5517 41.4117 35.8766C38.6132 30.2014 45.4971 23.286 38.6351 18.8401C31.7732 14.3942 37.0854 15.4864 37.0854 15.4864L37.0504 33.6376L27.8651 41.9652L9.20859 40.0711Z",
    fill: "url(#paint0_linear_900_3841)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4408 22.4032C36.4408 22.4032 35.6429 22.3568 37.4098 21.5654C39.1766 20.7739 42.4197 13.9027 38.9076 12.1734C35.3955 10.4441 38.6797 6.97508 37.4504 5.01303C36.2212 3.05099 34.8926 2.88098 31.9764 4.81928C29.0603 6.75757 23.4344 1.58057 21.4645 5.69011C19.4946 9.79965 22.8407 4.81022 22.8407 4.81022L31.0454 7.39133L36.22 11.9225L36.4408 22.4032Z",
    fill: "url(#paint1_linear_900_3841)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2816,
    cy: 24.3385,
    r: 15.2816,
    stroke: "#FAA9C6",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2472 9.09193C21.9854 8.90617 24.723 9.46123 27.1726 10.6988C29.6222 11.9364 31.6932 13.8108 33.1683 16.1251C34.6433 18.4394 35.4679 21.1083 35.5554 23.8514C35.6429 26.5944 34.99 29.3104 33.6654 31.714C32.3409 34.1176 30.3934 36.1202 28.0277 37.5113C25.6619 38.9025 22.9652 39.6308 20.2208 39.6199C17.4764 39.609 14.7856 38.8592 12.431 37.4493C10.0764 36.0394 8.14493 34.0214 6.8395 31.6074",
    stroke: "url(#paint2_linear_900_3841)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_3841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 33.9609C15.5927 33.9609 11.5625 29.9307 11.5625 24.9609C11.5625 19.9911 15.5927 15.9609 20.5625 15.9609C25.5323 15.9609 29.5625 19.9911 29.5625 24.9609C29.5625 29.9307 25.5323 33.9609 20.5625 33.9609Z",
    fill: "#3B579D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9026 33.9609V26.9895H25.2426L25.5936 24.2733H22.9026V22.5381C22.9026 21.7515 23.1204 21.2151 24.249 21.2151H25.6872V18.7869C25.4388 18.7545 24.5838 18.6807 23.5902 18.6807C21.5166 18.6807 20.0964 19.9461 20.0964 22.2717V24.2751H17.751V26.9913H20.0964V33.9609H22.9026Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_3841",
    x1: 10.5934,
    y1: 22.8522,
    x2: 64.4061,
    y2: 42.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_900_3841",
    x1: 26.5736,
    y1: 22.709,
    x2: 34.0769,
    y2: -8.44413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_900_3841",
    x1: 22.3097,
    y1: -2.32805,
    x2: 24.5982,
    y2: 69.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_3841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11.5625 15.9609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfacebookicon);
export default __webpack_public_path__ + "static/media/mfacebookicon.3bf9c2459ddeab46b4fda7dad77a360f.svg";
export { ForwardRef as ReactComponent };